import React from 'react';
import { flow } from 'lodash';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import { useDispatch } from 'react-redux';

import toaster from '@giro/shared-store/toaster';

import useFetchHook from '@giro-pdv/hooks/useFetch.hook';

import postApiTerminalsRegistrationsService from '@giro/shared-services/pdv/postApiTerminalsRegistrations.service';

const DialogCreateTerminalComponent = ({
  open,
  onClose,
  onCreated,
}: {
  open: boolean;
  onClose: () => void;
  onCreated: (created: any) => void;
}) => {
  const dispatch = useDispatch();

  const showToaster = flow(toaster.action.show, dispatch);

  const createFetch = useFetchHook(postApiTerminalsRegistrationsService, {
    requestOnMount: false,
  });

  const [alias, setAlias] = React.useState('');

  React.useEffect(() => {
    if (open) setAlias('');
  }, [open]);

  const creating = createFetch.loading;
  const canSubmit = Boolean(alias.trim()) && !creating;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    const [success, data] = await createFetch.handleFetch({
      alias: alias.trim(),
    });

    if (!success) {
      showToaster({
        message: 'Não foi possível criar o credenciamento do dispositivo.',
        variant: 'error',
      });
      return;
    }

    showToaster({
      message: 'Credenciamento criado. Apresente o QR Code ao dispositivo.',
      variant: 'success',
    });
    onCreated(data);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Adicionar dispositivo</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} pt={1}>
          <TextField
            autoFocus
            fullWidth
            size="small"
            required
            label="Nome do dispositivo"
            inputProps={{ maxLength: 255 }}
            value={alias}
            onChange={(ev) => setAlias(ev.target.value)}
            onKeyDown={(ev) => {
              if (ev.key === 'Enter') handleSubmit();
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={creating}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!canSubmit}
          startIcon={creating ? <CircularProgress size={16} /> : undefined}
        >
          Adicionar dispositivo
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogCreateTerminalComponent;
